import {
  Button,
  CenteredScreen,
  Flex,
  Heading,
  HtmlParser,
  SendEmailVisual,
  Text,
  VStack
} from '@payflip/ui/v2';
import { useAuth } from '../auth-provider';

type Props = {
  header: string;
  body: string;
  footer: string;
  resendButtonLabel: string;
  logoutDescription: string;
  logoutButtonLabel: string;
  onResendEmail: () => void;
  isLoading?: boolean;
};

export function EmailNotVerifiedPage({
  header,
  body,
  footer,
  resendButtonLabel,
  onResendEmail,
  isLoading,
  logoutDescription,
  logoutButtonLabel
}: Props): JSX.Element {
  const { signOut } = useAuth();

  return (
    <CenteredScreen noHeader>
      <VStack w="400px" textAlign="center" gap="16px">
        <SendEmailVisual width={120} />
        <Heading
          w="300px"
          fontSize="xl"
          textAlign="center"
          fontWeight="semibold"
          lineHeight="normal"
          mt="32px"
        >
          {header}
        </Heading>
        <HtmlParser html={body} />
        <Flex align="center" pt="16px">
          <Text>
            {footer}
            <Button
              p={0}
              size="md"
              ml="space_unit.x1"
              my={0}
              variant="tertiary"
              isLoading={isLoading}
              onClick={onResendEmail}
            >
              {resendButtonLabel}
            </Button>
          </Text>
        </Flex>

        <Flex align="center" pt="16px">
          <Text>
            {logoutDescription}
            <Button
              p={0}
              size="md"
              variant="tertiary"
              ml="space_unit.x1"
              onClick={() => signOut()}
            >
              {logoutButtonLabel}
            </Button>
          </Text>
        </Flex>
      </VStack>
    </CenteredScreen>
  );
}
